// This file was auto-generated by Fern from our API Definition.
export const AgentaApiEnvironment = {
    Default: "http://localhost/api",
};
